import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import ChatWidget from "./components/ChatWidget";
import WhatsAppSetup from "./components/WhatsAppSetup";
import { Settings } from "lucide-react";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/setup" element={<SetupPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

const SetupPage = () => {
  const navigate = useNavigate();
  return <WhatsAppSetup onBack={() => navigate('/')} />;
};

const Home = () => {
  const navigate = useNavigate();
  const [showChat, setShowChat] = useState(true);

  useEffect(() => {
    // Auto-open chatbot when user enters the page
    setShowChat(true);
  }, []);

  return (
    <div className="whatsapp-container">
      {/* WhatsApp Group Background Simulation */}
      <div className="whatsapp-bg">
        <div className="whatsapp-header">
          <div className="flex items-center gap-3">
            <div>
              <h1 className="text-gray-900 font-semibold text-base">BMP Yellow Pages</h1>
              <p className="text-gray-700 text-xs">Community Group</p>
            </div>
          </div>
          
          {/* Settings Button */}
          <button 
            onClick={() => navigate('/setup')}
            className="w-10 h-10 rounded-full bg-white/30 flex items-center justify-center hover:bg-white/50 transition-colors"
            data-testid="settings-btn"
            title="WhatsApp Integration Setup"
          >
            <Settings className="w-5 h-5 text-white" />
          </button>
        </div>
        
        {/* Sample group messages background */}
        <div className="whatsapp-chat-bg">
          <div className="sample-messages">
            <div className="sample-msg left">
              <p className="text-xs text-gray-500 mb-1">Shiva</p>
              <p>Good morning everyone! 👋</p>
              <span className="msg-time">9:15 AM</span>
            </div>
            <div className="sample-msg left">
              <p className="text-xs text-gray-500 mb-1">Parvati</p>
              <p>Has anyone used a good electrician recently?</p>
              <span className="msg-time">9:22 AM</span>
            </div>
            </div>
        </div>
      </div>

      {/* Chat Widget */}
      <ChatWidget isOpen={showChat} onClose={() => setShowChat(false)} onOpen={() => setShowChat(true)} />
    </div>
  );
};

export default App;
